import { useEffect } from "react";
import { Route, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  const globalState = useSelector((state) => state.userReducer);
  const navigate = useNavigate();

  // Code commented to
  useEffect(() => {
    if (globalState?.isUserLoggedIn) {
      navigate("/center-dashboard");
    }
  }, []);

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default PublicRoute;
